import React, { useState } from 'react';
import Icon from '../AppIcon';
import { useCompanySettings } from '../../contexts/CompanySettingsContext';

const LegalDisclaimerBanner = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const { companySettings } = useCompanySettings();

  const companyName = companySettings?.companyName || 'Your Company';
  const companyLegalName = companySettings?.companyLegalName || companyName;

  if (isDismissed) return null;

  return (
    <div className="bg-warning/10 border-t border-b border-warning/30">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-4">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 mt-0.5">
            <Icon name="AlertTriangle" size={20} className="text-warning" />
          </div>
          <div className="flex-1">
            <div className="flex items-start justify-between mb-2">
              <h3 className="text-sm font-semibold text-foreground flex items-center gap-2">
                Disclaimer of Legal Advice and Liability
                <button
                  onClick={() => setIsExpanded(!isExpanded)}
                  className="text-primary hover:text-primary/80 transition-colors"
                >
                  <Icon name={isExpanded ? 'ChevronUp' : 'ChevronDown'} size={16} />
                </button>
              </h3>
              <button
                onClick={() => setIsDismissed(true)}
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                <Icon name="X" size={16} />
              </button>
            </div>
            
            {isExpanded ? (
              <div className="text-sm text-foreground space-y-2">
                <p>
                  This application provides tools, templates, and calculators based on publicly available information from the Papua New Guinea Employment Act 1978 and related labor laws. The content is offered for general informational and administrative purposes only and does not constitute legal advice.
                </p>
                <p>
                  Employers and users remain responsible for ensuring compliance with all applicable laws and regulations. While every effort is made to keep information accurate and up to date, {companyLegalName} makes no warranties or guarantees regarding the completeness, accuracy, or applicability of the content to specific circumstances.
                </p>
                <p>
                  By using this application, you acknowledge that {companyLegalName} is not liable for any losses, penalties, or disputes arising from reliance on the information provided. Users are encouraged to consult the Department of Labour and Industrial Relations (DLIR) or qualified legal professionals for formal guidance.
                </p>
              </div>
            ) : (
              <p className="text-sm text-muted-foreground">
                This application provides tools based on PNG Employment Act 1978 for informational purposes only. Not legal advice. Click to read full disclaimer.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalDisclaimerBanner;